import { ChangeEvent, FC } from 'react';
import { JobCountQuery } from '@doda/common/src/services/getJobCountAPI';
import { EmploymentStatusRequestCode } from '@doda/api-client/aspida/@types';
import { ConditionsAreaWrapper } from 'components/SearchSideBar/ConditionsAreaWrapper';
import { EmploymentStatusListType } from 'types/employmentStatus';
import { SEARCH_EMPLOYMENT_OPTIONS } from 'constants/searchCondition';
import { useSelector } from 'react-redux';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { SearchCheckboxItem } from '../../SearchCheckboxList';
import { SearchConditionTitle } from '../SearchConditionTitle';
import styles from './index.module.scss';

/**
 * Props
 * @param list 表示用配列
 * @param updateIsChecked チェックボックス更新処理
 * @param updateJobCount 求人件数更新処理
 * @param onChangeIsShowOverlay オーバーレイ表示処理
 */
interface Props {
  list: EmploymentStatusListType[];
  updateIsChecked: (
    event: ChangeEvent<HTMLInputElement>,
    selectedId: string
  ) => EmploymentStatusRequestCode[];
  updateJobCount: (currentCondition?: JobCountQuery) => Promise<void>;
  onChangeIsShowOverlay: () => void;
}

/**
 * 検索サイドバー・雇用形態
 */
export const SearchEmploymentStatus: FC<Props> = ({
  list,
  updateIsChecked,
  updateJobCount,
  onChangeIsShowOverlay,
}) => {
  const { qc } = useSelector(appQueryParamsSelector);

  const onChangeCheckbox = (
    event: ChangeEvent<HTMLInputElement>,
    selectedValue: string
  ) => {
    const checkedList = updateIsChecked(event, selectedValue);
    updateJobCount({ employmentStatus: checkedList, qualificationId: qc });
    onChangeIsShowOverlay();
  };

  return (
    <ConditionsAreaWrapper>
      <div className={styles.searchCondition__titleWrapper}>
        <SearchConditionTitle title={SEARCH_EMPLOYMENT_OPTIONS.title} />
      </div>
      <ul className={styles.searchCheckboxList__container}>
        {list.map((item) => (
          <li key={item.id}>
            <SearchCheckboxItem
              title={item.name}
              value={item.value}
              isChecked={item.isChecked}
              count={item.jobCount}
              onChange={(event) => onChangeCheckbox(event, item.value)}
            />
          </li>
        ))}
      </ul>
    </ConditionsAreaWrapper>
  );
};
